import React from "react";
import { NotificationItemType } from "./notificationMockData";
import { notificationIconMap } from "./notificationIcons";
import { Circle } from "lucide-react";

interface Props {
  item: NotificationItemType;
  isDropdown?: boolean;
  onClick?: (item: NotificationItemType) => void;
}

const NotificationItem: React.FC<Props> = ({ item, isDropdown, onClick }) => {
  const { icon } = notificationIconMap[item.type];

  return (
    <div
      className={`d-flex align-items-start p-3 notification-item position-relative 
        ${item.isUnread ? "unread-bg" : ""}`}
      role={onClick ? "button" : undefined}
      onClick={onClick ? () => onClick(item) : undefined}
      style={{
        borderRadius: "10px",
        cursor: "pointer",
        borderLeft: "3px solid transparent",
        transition: "0.25s",
      }}
    >
      {/* Hover left border */}
      <style>{`
        .notification-item:hover {
          background: #f3f4f6 !important;
          border-left: 3px solid #155dfc !important;
        }
      `}</style>

      {/* Icon */}
      <div
        className="me-3 d-flex align-items-center justify-content-center"
        style={{
          width: 38,
          height: 38,
          borderRadius: "50%",
          background: notificationIconMap[item.type].color,
        }}
      >
        {icon}
      </div>

      {/* Text */}
      <div
        className="flex-grow-1"
        style={{ maxWidth: isDropdown ? "240px" : "100%" }}
      >
        <div className="fw-semibold text-dark" style={{ fontSize: "14px" }}>
          {item.title}
        </div>

        <div
          className="text-muted mt-1"
          style={{ fontSize: "13px", lineHeight: "18px" }}
        >
          {item.description}
        </div>

        <div
          className="text-muted mt-1"
          style={{ fontSize: "12px", marginTop: "3px" }}
        >
          {item.time}
        </div>
      </div>

      {/* Unread Blue Dot */}
      {item.isUnread && (
        <Circle
          size={10}
          fill="#155dfc"
          color="#155dfc"
          className="position-absolute"
          style={{ right: 10, top: 12 }}
        />
      )}
      <style>{`
        .unread-bg {
          background: #eff6ff !important;
        }
      `}</style>
    </div>
  );
};

export default NotificationItem;
